import type { FlowTypes as Action } from 'actions/seoContent'
import { Constants } from 'actions/seoContent'
import type { SeoContent } from 'types'
type State = SeoContent
export default function seoContent(state: State = {}, action: Action): State {
  switch (action.type) {
    case Constants.SET:
    case Constants.SET_PAGE:
      return { ...state, ...action.payload }

    default:
      return state
  }
}